(function () {
  function activateTab(tabs, panels, activeIndex, indexAttr) {
    tabs.forEach(function (tab) {
      var idx = tab.getAttribute(indexAttr);
      var isActive = String(idx) === String(activeIndex);
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.tabIndex = isActive ? 0 : -1;
    });

    panels.forEach(function (panel) {
      var idx = panel.getAttribute(indexAttr);
      var isActive = String(idx) === String(activeIndex);
      panel.classList.toggle('is-active', isActive);
      if (isActive) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });
  }

  function resetTrekMenu(root) {
    var l2Tabs = Array.prototype.slice.call(root.querySelectorAll('[data-trek-l2-tab]'));
    var l2Panels = Array.prototype.slice.call(root.querySelectorAll('[data-trek-l2-panel]'));
    if (!l2Tabs.length) return;

    activateTab(l2Tabs, l2Panels, '0', 'data-trek-l2-index');

    var firstL2 = root.querySelector('[data-trek-l2-panel][data-trek-l2-index="0"]');
    if (!firstL2) return;

    var l3Tabs = Array.prototype.slice.call(firstL2.querySelectorAll('[data-trek-l3-tab]'));
    var l3Panels = Array.prototype.slice.call(firstL2.querySelectorAll('[data-trek-l3-panel]'));
    if (l3Tabs.length) {
      activateTab(l3Tabs, l3Panels, '0', 'data-trek-l3-index');
    }
  }

  function initTrekMenu(root) {
    if (root.getAttribute('data-trek-ready') === 'true') return;
    root.setAttribute('data-trek-ready', 'true');

    root.addEventListener('click', function (event) {
      var l2Tab = event.target.closest('[data-trek-l2-tab]');
      if (l2Tab && root.contains(l2Tab)) {
        event.preventDefault();
        var l2Index = l2Tab.getAttribute('data-trek-l2-index');
        var l2Tabs = Array.prototype.slice.call(root.querySelectorAll('[data-trek-l2-tab]'));
        var l2Panels = Array.prototype.slice.call(root.querySelectorAll('[data-trek-l2-panel]'));
        activateTab(l2Tabs, l2Panels, l2Index, 'data-trek-l2-index');

        var panel = root.querySelector('[data-trek-l2-panel][data-trek-l2-index="' + l2Index + '"]');
        if (panel) {
          var l3Tabs = Array.prototype.slice.call(panel.querySelectorAll('[data-trek-l3-tab]'));
          var l3Panels = Array.prototype.slice.call(panel.querySelectorAll('[data-trek-l3-panel]'));
          if (l3Tabs.length) {
            activateTab(l3Tabs, l3Panels, '0', 'data-trek-l3-index');
          }
        }
        return;
      }

      var l3Tab = event.target.closest('[data-trek-l3-tab]');
      if (l3Tab && root.contains(l3Tab)) {
        event.preventDefault();
        var l2 = l3Tab.getAttribute('data-trek-l2-index');
        var l3 = l3Tab.getAttribute('data-trek-l3-index');
        var l2Panel = root.querySelector('[data-trek-l2-panel][data-trek-l2-index="' + l2 + '"]');
        if (!l2Panel) return;
        var l3Tabs = Array.prototype.slice.call(l2Panel.querySelectorAll('[data-trek-l3-tab]'));
        var l3Panels = Array.prototype.slice.call(l2Panel.querySelectorAll('[data-trek-l3-panel]'));
        activateTab(l3Tabs, l3Panels, l3, 'data-trek-l3-index');
      }
    });

    root.addEventListener('keydown', function (event) {
      var tab = event.target.closest('[role="tab"]');
      if (!tab || !root.contains(tab)) return;

      var group = tab.hasAttribute('data-trek-l2-tab')
        ? Array.prototype.slice.call(root.querySelectorAll('[data-trek-l2-tab]'))
        : Array.prototype.slice.call(tab.closest('[data-trek-l2-panel]').querySelectorAll('[data-trek-l3-tab]'));

      if (!group.length) return;
      var index = group.indexOf(tab);
      if (index < 0) return;

      var nextIndex = index;
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
        nextIndex = (index + 1) % group.length;
      } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
        nextIndex = (index - 1 + group.length) % group.length;
      } else if (event.key === 'Home') {
        nextIndex = 0;
      } else if (event.key === 'End') {
        nextIndex = group.length - 1;
      } else {
        return;
      }

      event.preventDefault();
      group[nextIndex].focus();
      group[nextIndex].click();
    });

    var navItem = root.closest('.navigation-item');
    if (navItem) {
      // Reset only when opening the mega menu from outside — not when
      // focusing/clicking links (product cards) inside the panel.
      navItem.addEventListener('mouseenter', function (event) {
        if (event.relatedTarget && root.contains(event.relatedTarget)) return;
        resetTrekMenu(root);
      });
      navItem.addEventListener('focusin', function (event) {
        if (event.target && root.contains(event.target)) return;
        resetTrekMenu(root);
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-mega-menu-trek]').forEach(initTrekMenu);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
